// extracted by mini-css-extract-plugin
module.exports = {"SliderWrapper":"ValueSlider_SliderWrapper__tyfJc","Slider":"ValueSlider_Slider__1KBo2","Rail":"ValueSlider_Rail__3M2S5"};